// extracted by mini-css-extract-plugin
export default {"bar":"ChatLockedBar_bar__M8kpN"};